import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ValuesSlider extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let initMin = this.props.initMin && this.props.valuesData.includes(this.props.initMin) ? this.props.initMin : this.props.valuesData[0];
    let initMax = this.props.initMax && this.props.valuesData.includes(this.props.initMax) ? this.props.initMax : this.props.valuesData[this.props.valuesData.length - 1];

    let initMinPos = 0.00;
    let initMaxPos = 1.00;

    if(this.props.initMin && this.props.valuesData.indexOf(this.props.initMin) >= 0) {
      initMinPos = this.props.valuesData.indexOf(this.props.initMin) / (this.props.valuesData.length - 1);
    }

    if(this.props.initMax && this.props.valuesData.indexOf(this.props.initMax) >= 0) {
      initMaxPos = this.props.valuesData.indexOf(this.props.initMax) / (this.props.valuesData.length - 1);
    }

		this.state = {
      
      scaleType: this.props.scale,
      numberFormat: this.props.format,

      cursorLeftPos: this.getClosestPosition(initMinPos),
      cursorRightPos: this.getClosestPosition(initMaxPos),

      currentMin: initMin,
      currentMax: initMax,

      dragActive: false,
      dragElement: null,

      inputWidth: this.props.inputWidth ? this.props.inputWidth : '80px',
    };

    // Bind event listeners
    this.dragStartLeft = ::this.dragStartLeft;
    this.dragStartRight = ::this.dragStartRight;
    this.dragEndAll = ::this.dragEndAll;
    this.moveSlider = ::this.moveSlider;
	}

	componentDidMount() {
    this.addClickHandlers(0);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.resetElement != prevProps.resetElement) {
      this.resetData();
    }
  }

  resetData() {
    this.setState({
      scaleType: this.props.scale,
      numberFormat: this.props.format,

      cursorLeftPos: 0.00,
      cursorRightPos: 1.00,

      currentMin: this.props.valuesData[0],
      currentMax: this.props.valuesData[this.props.valuesData.length - 1],

      dragActive: false,
      dragElement: null,

      inputWidth: this.props.inputWidth ? this.props.inputWidth : '80px',
    });
  }

  addClickHandlers() {
    if(this.leftHandle && this.rightHandle) {

      this.leftHandle.addEventListener('mousedown', this.dragStartLeft, false);
      this.leftHandle.addEventListener('touchstart', this.dragStartLeft, false);
  
      this.rightHandle.addEventListener('mousedown', this.dragStartRight, false);
      this.rightHandle.addEventListener('touchstart', this.dragStartRight, false);

      // window.addEventListener('mouseup', this.dragEndAll, false);
      // window.addEventListener('touchend touchcancel', this.dragEndAll, false);

      // window.addEventListener('mousemove', this.moveSlider, false);
      // window.addEventListener('touchmove', this.moveSlider, false);

      // End methods
      window.addEventListener('mouseup', this.dragEndAll, false);
      this.leftHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);

      window.addEventListener('mousemove', this.moveSlider, false);
      this.leftHandle.addEventListener('touchmove', this.moveSlider, false);

      this.rightHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);
      this.rightHandle.addEventListener('touchmove', this.moveSlider, false);

    } else {
      setTimeout(() => {
        this.addClickHandlers();
      }, 5);
    }
  }

  dragStartLeft() {

    if(this.props.disabled) {
      return;
    }

    this.setState({
      dragActive: true,
      dragElement: 'left',
    });
  }

  dragStartRight() {

    if(this.props.disabled) {
      return;
    }

    this.setState({
      dragActive: true,
      dragElement: 'right',
    });
  }

  dragEndAll() {

    if(this.state.dragActive) {
      if(this.props.translations) {
        this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.props.translations[this.state.currentMin], this.props.translations[this.state.currentMax]]);
      } else {
        this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
      }

      this.setState({
        dragActive: false,
        dragElement: null,
      });
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getStepSize() {
    return this.props.valuesData && this.props.valuesData.length > 1 ? (1.0 / (this.props.valuesData.length - 1)) : 1.0;
  }

  clickContained(evt) {

    if(this.state.dragActive) {

      let targetElement = evt.target;
      do {
        if (targetElement == this.rootObject) {
            return true;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should let go 
      return false;
    }
  }

  moveSlider(evt) {

    if(this.props.disabled) {
      return;
    }

    if(this.state.dragActive) {

      if(this.clickContained(evt) === false) {
        this.dragEndAll();
        return;
      }

      let rootElem = this.rootObject.getBoundingClientRect();
      let rootLeft = rootElem.left;
      let rootRight = rootElem.right;

      let leftPercent = this.state.cursorLeftPos;
      let rightPercent = this.state.cursorRightPos;

      if(this.state.dragElement == 'left') {
        
        let clientX = 0;
        if(evt.touches) {
          clientX = evt.touches[0].clientX;
        } else {
          clientX = evt.clientX;
        }
        let leftLength = clientX - rootLeft;

        if(leftLength < 0) {
          let leftLength = 0.00;
        } else {

          leftPercent = leftLength / (rootRight - rootLeft);
          if(leftPercent > rightPercent) {
            leftPercent = rightPercent;
          }
        }
      }

      if(this.state.dragElement == 'right') {

        let clientX = 0;
        if(evt.touches) {
          clientX = evt.touches[0].clientX;
        } else {
          clientX = evt.clientX;
        }
        let rightLength = rootRight - clientX;

        if(rightLength < 0) {
          let rightLength = 1.00;
        } else {

          rightPercent = 1 - rightLength / (rootRight - rootLeft);
          if(rightPercent < leftPercent) {
            rightPercent = leftPercent;
          }
        }
      }

      let stepSize = this.getStepSize();
      // console.log(stepSize);

      // let curMin = null;
      // let curMax = null;
      // let valueRange = this.state.maxValue - this.state.minValue;

      // curMin = Math.round(leftPercent * valueRange + this.state.minValue);
      // curMax = Math.round(rightPercent * valueRange + this.state.minValue);

      let lPos = this.getClosestPosition(leftPercent);
      let rPos = this.getClosestPosition(rightPercent);

      this.setState({
        cursorLeftPos: lPos,
        cursorRightPos: rPos,
        currentMin: this.props.valuesData[Math.round(lPos / stepSize)],
        currentMax: this.props.valuesData[Math.round(rPos / stepSize)],
      });
    }
  }

  getClosestPosition(posPercent) {

    let stepSize = this.getStepSize();
    let stepList = [];

    for(let i = 0; i < this.props.valuesData.length; i++) {
      stepList.push(i * stepSize);
    }
    let closest = stepList.reduce(function(prev, curr) {
      return (Math.abs(curr - posPercent) < Math.abs(prev - posPercent) ? curr : prev);
    });

    return closest;

  }

  getLeftBarInlineStyles() {
    return {
      width: Math.round(this.state.cursorLeftPos * 100) + '%',
    }
  }

  getMiddleBarInlineStyles() {
    return {
      left: Math.round(this.state.cursorLeftPos * 100) + '%',
      right: Math.round((1 - this.state.cursorRightPos) * 100) + '%',
    }
  }

  getRightBarInlineStyles() {
    return {
      width: Math.round((1 - this.state.cursorRightPos) * 100) + '%',
    }
  }

  getLeftDotInlineStyles() {
    return {
      left: Math.round(this.state.cursorLeftPos * 100) + '%',
    }
  }

  getRightDotInlineStyles() {
    return {
      left: Math.round(this.state.cursorRightPos * 100) + '%',
    }
  }

	render() {
		return <div className={this.props.disabled ? 'ValuesSlider disabled' : 'ValuesSlider'} ref={(div) => { this.rootObject = div; }}>
			<div className='sliderWrapper'>
        <div className={'ticWrapper'}>
          {this.props.valuesData.map((val, i) => {
            return <div className='ticElement' style={{left: String((i * this.getStepSize() * 100) + '%')}} key={i}></div>;
          })}
        </div>
        <div className={'leftBar sliderBar'} style={this.getLeftBarInlineStyles()}></div>
        <div className={'middleBar sliderBar'} style={this.getMiddleBarInlineStyles()}></div>
        <div className={'rightBar sliderBar'} style={this.getRightBarInlineStyles()}></div>
        <div className={'rightBarTail sliderBar'}></div>
        <div className={'leftDot sliderDot'} style={this.getLeftDotInlineStyles()} ref={(div) => { this.leftHandle = div; }}></div>
        <div className={'rightDot sliderDot'} style={this.getRightDotInlineStyles()} ref={(div) => { this.rightHandle = div; }}></div>
      </div>
      
      <div className='inputWrapper'>
        <div className='dashWrapper'>&mdash;</div>
        <div className='minValWrapper'>
          <div className='minValData' style={{width: this.state.inputWidth}}>{this.state.currentMin}</div>
        </div>        
        <div className='maxValWrapper'>
          <div className='maxValData' style={{width: this.state.inputWidth}}>{this.state.currentMax}</div>
        </div>
      </div>
		</div>;
	}
}
export default ValuesSlider;

function mapStateToProps(state) {
  return {

  };
}

export const ValuesSliderContainer = connect(
  mapStateToProps,
  allActionCreators
)(ValuesSlider);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filterElements/ValuesSlider.jsx